<div *ngIf="permission?.canSeeBudget">
  <div class="header_search header_search_mobile">
    <div class="title-page">
      <h3>Execução Orçamentária</h3>
    </div>
    <div class="content_search">
      <div class="new-project" *ngIf="permission?.alterExec && permission?.canEdit">
        <button type="button" class="btn btn-primary btn" (click)="openModal()">Alterar</button>
      </div>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="permission?.budgetMonitoring">
    <h3 class="text-center">Execução Orçamentária não monitorada</h3>
  </div>

  <div class="alert alert-info" *ngIf="warnings?.length > 0">
    <h5>Inconsistências: </h5>
    <ol>
      <li *ngFor="let warning of warnings">{{ warning }}</li>
    </ol>
  </div>

  <form [formGroup]="form">
    <div class="system-table table-container table-form">
      <div class="system-table-conteiner system-table-form-conteiner">
        <table>
          <thead>
            <tr>
              <th>Exercício</th>
              <th class="text-center">Total planejado</th>
              <th class="text-center">Dotação LOA</th>
              <th class="text-center">Empenhado</th>
              <th class="text-center">Liquidado</th>
              <th class="text-center">
                Pago
                <button matButton="elevated" #tooltip="matTooltip"
                    matTooltip="No sistema FPE, corresponde à soma do Pago + Pagamento Regularizado"
                    class="btn-help"
                    matTooltipHideDelay="200"
                    aria-label="No sistema FPE, corresponde à soma do Pago + Pagamento Regularizado"
                    >
                  question_mark
                </button>
              </th>
              <th class="text-center">Liquidado Exercício Anterior</th>
              <th class="text-center">
                Pago Exercício Anterior
                <button matButton="elevated" #tooltip="matTooltip"
                    matTooltip="No sistema FPE, corresponde à soma do Pago + Pagamento Regularizado"
                    class="btn-help"
                    matTooltipHideDelay="200"
                    aria-label="No sistema FPE, corresponde à soma do Pago + Pagamento Regularizado"
                    >
                  question_mark
                </button>
              </th>
              <th class="text-center">Tipo registro</th>
              <th class="width5 text-center">Ações</th>
            </tr>
          </thead>
          <tbody formArrayName="execucao">
            <ng-container *ngFor="let item of totaisPorExecucao; let i = index" [formGroupName]="i">
              <tr>
                <td class="title">{{ item?.ano_exercicio }}</td>
                <td class="text-center" *ngIf="permission?.blocked || permission?.viewExec; else editPlanned">
                  {{ item?.valor_planejado | currency:'BRL':'symbol':'1.2-2' }}
                </td>
                <ng-template #editPlanned>
                  <td>
                    <div class="form-group row">
                      <div class="col-sm-12">
                        <input type="text" class="form-control text-right" formControlName="valor_planejado" (keyup)="formatarMedidaFisica(i, 'valor_planejado')">
                      </div>
                    </div>
                  </td>
                </ng-template>
                <td class="text-center">{{ item?.total_dotacao | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-center">{{ item?.total_empenhado | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-center">{{ item?.total_liquidado | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-center">{{ item?.total_pago | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-center">{{ item?.total_liquidado_exercicio_anterior | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-center">{{ item?.total_pago_exercicio_anterior | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-center">{{ item?.tipo_integracao_label }}</td>
                <td>
                  <div class="btn-icon">
                    <a class="icon-table" [routerLink]="view(item?.id)">
                      <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                    </a>
                  </div>
                </td>
              </tr>
            </ng-container>
            <tr>
              <td class="title"><strong>Total</strong></td>
              <td class="text-center"><b>{{ totais?.valor_planejado | currency:'BRL':'symbol':'1.2-2' }}</b></td>
              <td class="text-center"><b>{{ totais?.dotacao_loa | currency:'BRL':'symbol':'1.2-2' }}</b></td>
              <td class="text-center"><b>{{ totais?.empenhado | currency:'BRL':'symbol':'1.2-2' }}</b></td>
              <td class="text-center"><b>{{ totais?.liquidado | currency:'BRL':'symbol':'1.2-2' }}</b></td>
              <td class="text-center"><b>{{ totais?.pago | currency:'BRL':'symbol':'1.2-2' }}</b></td>
              <td class="text-center"><b>{{ totais?.liquidado_exercicio_anterior | currency:'BRL':'symbol':'1.2-2' }}</b></td>
              <td class="text-center"><b>{{ totais?.pago_exercicio_anterior | currency:'BRL':'symbol':'1.2-2' }}</b></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>

  <div class="teste" *ngIf="permission?.viewExec">
    <div class="info-page">
      <h3>Previsão de Execução Orçamentária (liquidação)</h3>
    </div>

    <form [formGroup]="formPrevisao" (ngSubmit)="salvar()">
      <div class="system-table table-container table-form">
        <div class="system-table-conteiner system-table-form-conteiner">
          <table>
            <thead>
              <tr>
                <th class="text-center">Ano</th>
                <th class="text-center">Total planejado</th>
                <th class="text-center">Previsão LOA</th>
                <th class="text-center">Nova previsão</th>
                <th class="text-center">Realizado (liquidado)</th>
              </tr>
            </thead>
            <tbody formArrayName="previsao">
              <ng-container *ngFor="let item of execucaoPrevisaoList; let i = index" [formGroupName]="i">
                <tr>
                  <td class="title text-center">{{ item?.ano_exercicio }}</td>
                  <td>
                    <div class="form-group">
                      <div class="col-sm-12">
                        <input type="text" class="form-control text-right" formControlName="total_planejado" (keyup)="formatarMedidaFisica(i, 'total_planejado', true)">
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="form-group">
                      <div class="col-sm-12">
                        <input type="text" class="form-control text-right" formControlName="previsao_loa" (keyup)="formatarMedidaFisica(i, 'previsao_loa', true)">
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="form-group">
                      <div class="col-sm-12">
                        <input type="text" class="form-control text-right" formControlName="nova_previsao" (keyup)="formatarMedidaFisica(i, 'nova_previsao', true)">
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="form-group">
                      <div class="col-sm-12">
                        <input type="text" class="form-control text-right" formControlName="liquidado" (keyup)="formatarMedidaFisica(i, 'liquidado', true)">
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
              <tr>
                <td class="title text-center"><strong>Total</strong></td>
                <td class="text-right">{{ totais_execucaoPrevisaoList?.total_planejado | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-right">{{ totais_execucaoPrevisaoList?.previsao_loa | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-right">{{ totais_execucaoPrevisaoList?.nova_previsao | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td class="text-right">{{ totais_execucaoPrevisaoList?.liquidado | currency:'BRL':'symbol':'1.2-2' }}</td>
              </tr>
              <tr class="info">
                <td class="title text-center"><strong>Valor estimado projeto</strong></td>
                <td class="text-right">{{ total_projeto?.total_projeto | currency:'BRL':'symbol':'1.2-2' }}</td>
                <td></td>
                <td class="text-center"><strong>Total previsão + realizado</strong></td>
                <td class="text-right">{{ total_projeto?.total_previsto | currency:'BRL':'symbol':'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-primary btn" *ngIf="permission?.canEdit" type="button" (click)="salvar()">Salvar</button>
    </div>
  </div>

  <ng-template #modal>
    <div class="modal-header">
      <h4 class="modal-title pull-left">Período</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body table-form">
      <div class="form-group row">
        <div class="col-sm-6 m-b">
          <label class="col-sm-12 pb-1">Início da tabela</label>
          <input id="dt_start_action" class="form-control" [(ngModel)]="execucaoAlterar.year_ini" maxlength="4" (keyup)="maskNumber($event)">
        </div>

        <div class="col-sm-6 m-b">
          <label class="col-sm-12 pb-1">Término da tabela</label>
          <input id="dt_deadline" class="form-control" [(ngModel)]="execucaoAlterar.year_end" maxlength="4" (keyup)="maskNumber($event)" [ngClass]="{'invalid': this.execucaoAlterar.erroText}">
          <app-field-message [field]="execucaoAlterar.erroText" [erros]="execucaoAlterar.erroText" [textErroServer]="execucaoAlterar?.erroText"></app-field-message>
        </div>
      </div>

      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="closeModal()">Voltar</button>
          <button class="btn btn-primary" type="button" (click)="gerar()">Gerar</button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<br>
<app-historico-atualizacoes-list [audit]="audit" *ngIf="permission?.canSeeBudget"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>